export const firebaseConfig = {
  apiKey: "AIzaSyCGA8G-qLU6HR8hnj3cO4OCiZ4euupwRdw",
  authDomain: "questions-and-answers-ee67f.firebaseapp.com",
  projectId: "questions-and-answers-ee67f",
  storageBucket: "questions-and-answers-ee67f.firebasestorage.app",
  messagingSenderId: "448541880305",
  appId: "1:448541880305:web:e2a6f12c6bb2a4f79dde50",
  measurementId: "G-RR99MTH0QV",
};
